import React from 'react';
import { Zap, RotateCcw } from 'lucide-react';

const TestButton = ({ currentPhase, isActive, onStart, onReset }) => {
  return (
    <button
      onClick={currentPhase === 'idle' ? onStart : onReset}
      disabled={isActive}
      className={`bg-[#1E9B4C] hover:bg-green-600 dark:bg-green-600 dark:hover:bg-green-700 text-white px-12 py-4 rounded-2xl font-bold text-lg transition-colors ${
        isActive ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >
      {isActive ? (
        <div className="flex items-center space-x-2">
          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>Testing...</span>
        </div>
      ) : currentPhase === 'complete' ? (
        <div className="flex items-center space-x-2">
          <RotateCcw size={20} />
          <span>Test Again</span>
        </div>
      ) : (
        <div className="flex items-center space-x-2">
          <Zap size={20} />
          <span>Start Test</span>
        </div>
      )}
    </button>
  );
};

export default TestButton;